export const SHOW_MODAL_DIALOG = 'SHOW_MODAL_DIALOG';
export const HIDE_MODAL_DIALOG = 'HIDE_MODAL_DIALOG';



// WEBPACK FOOTER //
// ./src/blocks/modal-dialog/consts.js